import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material.module';
import { QuickBooksSyncAdminComponent } from './quickbooks-sync-admin.component';
import { QuickBooksSyncAdminData } from './quickbooks-sync-admin.data';
import { QuickBooksSyncAdminRoutes } from './quickbooks-sync-admin.routing';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule.forChild(QuickBooksSyncAdminRoutes)
  ],
  declarations: [QuickBooksSyncAdminComponent],
  providers: [QuickBooksSyncAdminData]
})
export class QuickBooksSyncAdminMdl { }
